// removed by extract-text-webpack-plugin
module.exports = {"base":"_1Gako","fulltop":"_7UPVZ","base_bred":"OSLfV","rubrik":"_2cUxl _1Gako","rubrikcenter":"Kdowl OSLfV","rubrikxl":"wb3jh _1Gako","rubrikneg":"OIGjS _7UPVZ","rubrikmager":"iRQLH _1Gako","rubrik2":"_1PO-X _1Gako","rubrik3":"KpXUb _1Gako","mellanrubrik":"MlD0r _1Gako","rubrik4":"_31otb _1Gako","rubrik5":"KdiBX _1Gako"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Rubrik/Rubrik.scss
 ** module id = 461
 ** module chunks = 0
 **/